/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskPaginatedRequestedProcessesResponse
 */
export interface ExecRiskPaginatedRequestedProcessesResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedRequestedProcessesResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExecRiskPaginatedRequestedProcessesResponse
     */
    results: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedRequestedProcessesResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedRequestedProcessesResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedRequestedProcessesResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedRequestedProcessesResponse interface.
 */
export function instanceOfExecRiskPaginatedRequestedProcessesResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedRequestedProcessesResponseFromJSON(json: any): ExecRiskPaginatedRequestedProcessesResponse {
    return ExecRiskPaginatedRequestedProcessesResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedRequestedProcessesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedRequestedProcessesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': json['results'],
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedRequestedProcessesResponseToJSON(value?: ExecRiskPaginatedRequestedProcessesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': value.results,
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

